import React from 'react';
import { Grid } from '@mui/material';

import { getMembersFromMembers } from '../../services/tactonService';

function MemberSummaryComponent(props) {
  const {
    member,
    showGroupHeader,
    isBomInfo,
    isBomSummary,
    sequence,
    quantity,
    col,
    isTable
  } = props;

  const isHidden = () => {
    if (!member.properties) return false;

    if (member.properties.hidden == 'yes') return true;

    if (member.description == 'Section Position') return true;

    return false;
  };

  const showHeader = () => {
    return isGroup() && hasChildren() && showGroupHeader;
  };

  const isGroup = () => {
    return member.isGroup;
  };

  const hasChildren = () => {
    var children = getMembersFromMembers(member).filter(
      x => !x.isGroup && x.properties.hidden != 'yes'
    );
    return children.length > 0;
  };

  const nameTranslation = () => {
    return member.description;
  };

  const isDisplayGroup = () => {
    return (
      member.properties &&
      member.properties.ph_show_group_heading == 'yes' &&
      !showGroupHeader
    );
  };

  const children = () => {
    if (!member.isGroup) return [];

    return member.members.filter(x => !x.name.includes('add_segment'));
  };

  return (
    <>
      {!isHidden(member) && (
        <>
          {showHeader() && (
            <div className="option-summary-category" key={member.name}>
              {member.description}
            </div>
          )}
          {!isGroup() && (
            <div key={member.name}>
              {isBomInfo ? (
                <Grid item className="attribute-description">
                  {member.valueDescription} :
                </Grid>
              ) : (
                <Grid container>
                  {isBomSummary && (
                    <Grid
                      item
                      lg={col}
                      md={col}
                      sm={isTable ? col : 12}
                      xs={isTable ? col : 12}
                      className="attribute-value word-wrap"
                    >
                      {sequence}
                    </Grid>
                  )}
                  {isBomSummary && (
                    <Grid
                      item
                      lg={col}
                      md={col}
                      sm={isTable ? col : 12}
                      xs={isTable ? col : 12}
                      className="attribute-value word-wrap"
                    >
                      {quantity}
                    </Grid>
                  )}
                  {!isBomSummary && (
                    <Grid
                      item
                      lg={col}
                      md={col}
                      sm={isTable ? col : 12}
                      xs={isTable ? col : 12}
                      className="attribute-description word-wrap"
                    >
                      {member.description}
                    </Grid>
                  )}
                  <Grid
                    item
                    lg={col}
                    md={col}
                    sm={isTable ? col : 12}
                    xs={isTable ? col : 12}
                    className="attribute-value word-wrap"
                  >
                    {member.valueDescription}
                  </Grid>
                  {isBomSummary && (
                    <Grid
                      item
                      lg={col}
                      md={col}
                      sm={isTable ? col : 12}
                      xs={isTable ? col : 12}
                      className="attribute-value word-wrap"
                    >
                      {member.description}
                    </Grid>
                  )}
                </Grid>
              )}
            </div>
          )}

          {isDisplayGroup() && (
            <Grid
              item
              lg={col}
              md={col}
              sm={12}
              xs={12}
              className="summary-group"
              key={member.name}
            >
              {member.description} :
            </Grid>
          )}

          {children()?.map(child => {
            return (
              <div key={member.name + '_' + child.name}>
                <MemberSummaryComponent
                  member={child}
                  showGroupHeader={showGroupHeader}
                  isBomSummary={isBomSummary}
                  sequence={sequence}
                  quantity={quantity}
                  col={col}
                />
              </div>
            );
          })}
        </>
      )}
    </>
  );
}

export default MemberSummaryComponent;
